import { z } from 'zod';

export const AlertaUiSchema = z.object({
  id: z.string(),
  encabezado: z.string(),
  descripcion: z.string(),
  fecha_creacion_alerta: z.string(),
  estado_alerta: z.string(),
  isRead: z.boolean()
});

export type AlertaUi = z.infer<typeof AlertaUiSchema>; 